<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1 style="margin-bottom:-35px;">Dedication</h1>
<p style="text-align: center;">To Scott and Lara</p>
<p style="text-align: center;">and</p><br/><br/>
<p style="text-align: center;">To Dog Lovers Everywhere</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?411e472e